import Fetcher from '../../utility/Fetcher';
import ErrorHandler from '../../utility/ErrorHandler';
import { FetchingModel, InvalidCadastreKeySubmitted } from '../../Events';
import Swal from 'sweetalert2';

const INVALID_CADASTRE_KEY_SUBMITTED_MESSAGE = 'Ugyldig matrikkel';

const delim: RegExp = new RegExp(/[^0-9]/);

export function init(tag: any): void {
  tag.on('mount', () => {
    ErrorHandler.addListener(InvalidCadastreKeySubmitted, onInvalidCadastreKeySubmitted);
    Fetcher.addListener(FetchingModel, onFetchingModel);
  });
  tag.on('unmount', () => {
    ErrorHandler.removeListener(InvalidCadastreKeySubmitted, onInvalidCadastreKeySubmitted);
    Fetcher.removeListener(FetchingModel, onFetchingModel);
  });
  // TODO: Replace alert with a small text underneath the search form indicating that the key was invalid
  function onInvalidCadastreKeySubmitted(): void {
    Swal.fire({
      title: INVALID_CADASTRE_KEY_SUBMITTED_MESSAGE,
      type: 'warning',
      showConfirmButton: false,
      timer: 2000,
      allowEscapeKey: true,
      allowOutsideClick: true,
      animation: false
    });
  }

  function onFetchingModel(): void {
    tag.key.value = Fetcher.fetchedCadastreKey();
  }

  tag.search = () => {
    if (tag.key.value.length === 0) {
      return;
    }
    const keyComponents: string[] = tag.key.value.split(delim);
    if (keyComponents[keyComponents.length - 1] === '') {
      keyComponents.pop();
    }
    const threeComponents = 3;
    const fourComponents = 4;
    switch (keyComponents.length) {
      case threeComponents:
        keyComponents.push('0');
        break;
      case fourComponents:
        keyComponents.push('0');
        break;
      default:
        break;
    }
    let key = '';
    for (let i = 0; i < keyComponents.length; ++i) {
      key += keyComponents[i] + '-';
    }
    Fetcher.fetchModelData(key.substring(0, key.length - 1));
  };
}



/** WEBPACK FOOTER **
 ** ./src/components/housingValueSearchBar/SearchFormController.ts
 **/